import JobApplicationHelper from './models/JobApplicationHelper';

export default { jobApplications: JobApplicationHelper };
